export default __webpack_public_path__ + "static/test-tutorial-en-6f1da88988896799a5dbdf9c7a517a51.mp4";